var map = {
	"./cardBG.png": 868,
	"./cardBG_bun.png": 5971,
	"./cardBG_bun2.png": 1624,
	"./cardBG_bun3.png": 462,
	"./cardBG_ema.png": 7523,
	"./cardBG_hatsuki.png": 9814,
	"./dot_bun.png": 4297,
	"./dot_hatsuki.png": 284,
	"./dot_kinka.png": 2937,
	"./ema_icon.png": 7499,
	"./fonts/yasashisa.ttf": 9477,
	"./frame_hatsuki.png": 4792,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./logo_bun.png": 9672,
	"./logo_kinka.png": 8357,
	"./messages/en": 4814,
	"./messages/en.json": 4814,
	"./messages/ja": 4255,
	"./messages/ja.json": 4255,
	"./naru01.jpg": 8837,
	"./naru02.jpg": 5226,
	"./naru03.jpg": 5607,
	"./naru04.jpg": 1041,
	"./snow_dome.png": 1733,
	"./uniBG01.png": 9150,
	"./uniBG02.png": 4341,
	"./uniBG03.png": 9984,
	"./uniBG04.png": 8435,
	"./uniBG05.png": 8123,
	"./uniBG06.png": 6228,
	"./unikinka.png": 6855,
	"./waffu01.jpeg": 1155,
	"./waffu02.jpeg": 9562,
	"./waffu03.jpeg": 8657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;